/**
 * Vehicle trait module
 */

export * from './vehicleTrait';
export * from './vehicleBehavior';
